import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";
import type { ApiResponse } from "./api-client.service";

import type {
  RoleModuleAccess,
  RoleModuleAccessFilter,
  RoleModuleAccessResponse,
  RoleModuleAccessPayload,
} from "../types/rbac-role-module-access.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.rbacRoleModulesAccess;

const failure = (error: unknown, fallback: string) => ({
  success: false,
  statusCode: 500,
  message: error instanceof Error ? error.message : fallback,
  resData: null,
});

export const rbacRoleModuleAccessService = {
  async list(filter: RoleModuleAccessFilter): Promise<RoleModuleAccessResponse> {
    try {
      const params = new URLSearchParams();
      Object.entries(filter).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, String(value));
        }
      });

      return await apiClient<RoleModuleAccessResponse>(endpoints.list(params.toString()), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load role-module-access list.") as unknown as RoleModuleAccessResponse;
    }
  },

  async details(id: number | string): Promise<ApiResponse<RoleModuleAccess>> {
    try {
      return await apiClient<ApiResponse<RoleModuleAccess>>(endpoints.details(id), {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return failure(error, "Failed to load role-module-access details.") as unknown as ApiResponse<RoleModuleAccess>;
    }
  },

  async create(payload: RoleModuleAccessPayload): Promise<ApiResponse<RoleModuleAccess>> {
    try {
      return await apiClient<ApiResponse<RoleModuleAccess>>(endpoints.create, {
        method: "POST",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to create role-module-access.") as unknown as ApiResponse<RoleModuleAccess>;
    }
  },

  async update(id: number | string, payload: Partial<RoleModuleAccessPayload>): Promise<ApiResponse<RoleModuleAccess>> {
    try {
      return await apiClient<ApiResponse<RoleModuleAccess>>(endpoints.update(id), {
        method: "PATCH",
        body: JSON.stringify(payload),
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to update role-module-access.") as unknown as ApiResponse<RoleModuleAccess>;
    }
  },

  async delete(id: number | string): Promise<ApiResponse<unknown>> {
    try {
      return await apiClient<ApiResponse<unknown>>(endpoints.delete(id), {
        method: "DELETE",
        isAuthenticated: true,
      });
    } catch (error) {
      return failure(error, "Failed to delete role-module-access.") as unknown as ApiResponse<unknown>;
    }
  },
};
